import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

interface PasswordValidationProps {
  password: string;
  className?: string;
}

interface PasswordValidation {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  special: boolean;
}

const PasswordValidation: React.FC<PasswordValidationProps> = ({ password, className = '' }) => {
  const validatePassword = (password: string): PasswordValidation => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    };
  };

  const validation = validatePassword(password);
  const isPasswordValid = Object.values(validation).every(Boolean);

  if (!password) return null;

  const ValidationItem: React.FC<{ isValid: boolean; text: string }> = ({ isValid, text }) => (
    <div className="d-flex align-items-center gap-2">
      {isValid ? (
        <CheckCircle size={16} className="text-success" />
      ) : (
        <XCircle size={16} className="text-danger" />
      )}
      <span className={isValid ? 'text-success' : 'text-muted'}>{text}</span>
    </div>
  );

  return (
    <div className={`mt-2 p-3 bg-light rounded ${className}`}>
      <small className="text-muted d-block mb-2">Critérios de segurança:</small>
      <div className="d-flex flex-column gap-1">
        <ValidationItem isValid={validation.length} text="Pelo menos 8 caracteres" />
        <ValidationItem isValid={validation.uppercase} text="Uma letra maiúscula" />
        <ValidationItem isValid={validation.lowercase} text="Uma letra minúscula" />
        <ValidationItem isValid={validation.number} text="Um número" />
        <ValidationItem isValid={validation.special} text="Um caractere especial" />
      </div>
    </div>
  );
};

export default PasswordValidation;
